import { faqData } from "./data"
import FAQSection from '@components/FAQSection'
export const Faq = ()=>{
    return(
    <section className="container">

                  <FAQSection faqData={faqData}  />
    </section>

    )
}